import { StatusBadge } from '@/components/common/StatusBadge';
import {
  REVIEW_STATUS_LABELS,
  REVIEW_STATUS_TONE,
  type ReviewStatus,
} from '@/constants/reviewStatus';

interface TeacherInactivationStatusBadgeProps {
  status: ReviewStatus;
  className?: string | undefined;
}

export function TeacherInactivationStatusBadge({
  status,
  className,
}: TeacherInactivationStatusBadgeProps) {
  return (
    <StatusBadge tone={REVIEW_STATUS_TONE[status]} className={className}>
      {REVIEW_STATUS_LABELS[status]}
    </StatusBadge>
  );
}
